// A tiny dependency-free WYSIWYG editor (contentEditable + execCommand) that
// emits HTML. Used for the lesson content textareas (body, reflection), the
// course summary, and reader notes. Pairs with <RichText> for display.
import { useEffect, useRef } from 'react';
import './richtext.css';

const exec = (cmd, arg) => document.execCommand(cmd, false, arg);

export default function RichTextEditor({ value, onChange, placeholder, minHeight = 90 }) {
  const ref = useRef(null);

  // Sync external value in (initial mount, reorder, load) without clobbering
  // the caret while the user is typing.
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const v = value || '';
    if (el.innerHTML !== v && document.activeElement !== el) el.innerHTML = v;
  }, [value]);

  const emit = () => { if (ref.current) onChange(ref.current.innerHTML); };
  const run = (cmd, arg) => (e) => { e.preventDefault(); ref.current?.focus(); exec(cmd, arg); emit(); };
  const addLink = (e) => {
    e.preventDefault();
    const url = window.prompt('Link URL:');
    if (url) { ref.current?.focus(); exec('createLink', url); emit(); }
  };

  return (
    <div className="rte">
      <div className="rte-toolbar">
        <button type="button" className="rte-btn" title="Bold" onMouseDown={run('bold')}><b>B</b></button>
        <button type="button" className="rte-btn" title="Italic" onMouseDown={run('italic')}><i>I</i></button>
        <button type="button" className="rte-btn" title="Heading" onMouseDown={run('formatBlock', 'H2')}>H</button>
        <button type="button" className="rte-btn" title="Bulleted list" onMouseDown={run('insertUnorderedList')}>•</button>
        <button type="button" className="rte-btn" title="Numbered list" onMouseDown={run('insertOrderedList')}>1.</button>
        <button type="button" className="rte-btn" title="Link" onMouseDown={addLink}>🔗</button>
        <button type="button" className="rte-btn" title="Clear formatting" onMouseDown={run('removeFormat')}>⨯</button>
      </div>
      <div
        ref={ref}
        className="rte-area"
        contentEditable
        suppressContentEditableWarning
        data-placeholder={placeholder || ''}
        style={{ minHeight }}
        onInput={emit}
        onBlur={emit}
      />
    </div>
  );
}
